import Navbar from "../components/Navbaar";
import Footer from "../components/Footer";
import SEO from "../components/SEO/SEO";
import styles from "./About.module.css";

function About() {
  return (
    <>
      <SEO
        title="About | BOI Gardens & Car Cleaning"
        description="Local garden care and car cleaning, based in Kerikeri, New Zealand."
      />

      <Navbar />

      <main className={styles.page}>
        <div className={styles.wrap}>
          <div className={styles.copy}>
            <span className="eyebrow">About us</span>
            <h1>A small local team, doing two jobs properly</h1>
            <p>
              BOI Gardens &amp; Car Cleaning proudly serves Kerikeri and
              nearby communities with professional garden maintenance and
              vehicle cleaning services.
            </p>
            <p>
              The idea is simple: most people who need their garden tidied
              also want their car cleaned, so we do both — reliably, on
              time, and at a fair price — instead of you having to book two
              separate businesses.
            </p>
            <p>
              Every job is priced upfront and every visit is treated like
              it's the only one that matters that day.
            </p>
          </div>

          <div className={`${styles.quoteCard} floatSlow`}>
            {/* <span className={styles.quoteMark} aria-hidden="true">
              &ldquo;
            </span> */}
            <p>Tidy sections, shining cars, no surprises on price.</p>
            <span>Michael Crichton, Owner</span>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default About;
